export const en = {
  common: {
    appName: "eHEALTH",
    search: "Search",
    searchPlaceholder: "Search in the app...",
    favorites: "Favorites",
    notifications: "Notifications",
    noNewNotifications: "No new notifications",
    messages: "Messages",
    cart: "Cart",
    logout: "Log out",
    session: "Session",
    settings: "Settings",
    theme: "Theme",
    language: "Language",
    inDevelopment: "In development",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    back: "Back",
    next: "Next",
    submit: "Submit",
    activate: "Activate",
    register: "Register",
    apply: "Apply",
    book: "Book",
    pay: "Pay",
    download: "Download",
    upload: "Upload",
    share: "Share",
    view: "View",
    filter: "Filter",
    sortBy: "Sort by",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    completed: "Completed",
    cancelled: "Cancelled",
    free: "Free",
    noData: "No data available",
    error: "Error",
    tenantScopeDenied: "Access is restricted at clinic level.",
    success: "Success",
    required: "Required",
    optional: "Optional",
    eur: "EUR",
  },
  appointment_created: "The appointment was created successfully and added to the clinical schedule.",
  laboratory_case_created: "The laboratory case was created and is pending processing.",
  laboratory_results_ready: "Laboratory results are ready for clinical review.",
  laboratory_case_delivered: "Laboratory results were delivered to the patient.",
  payment_success: "Payment completed successfully.",
  LARGE_TRANSACTION: "A large transaction requiring attention was detected.",
  service_subscription_activated: "The module subscription was activated.",
  service_subscription_expired: "The module subscription has expired.",
  inventory_incident_reported: "An equipment incident was reported.",
  business_invoice_created: "A new B2B invoice was created.",
  verification: {
    requestedSuccess: "Your request was sent to the administrator.",
    requirementsMissing: "To request verification, you must be a member of a verified clinic.",
  },
  security: {
    setPin: "Set PIN",
    pinRequired: "Please set your PIN to unlock profile editing.",
    pinSuccess: "PIN was saved.",
  },
  media: {
    uploading: "Uploading file...",
    allowedImageFormat: "Allowed format: JPG, PNG",
    uploadSuccess: "File saved successfully",
    uploadFile: "Upload file",
    dropOrClick: "Click or drag the file here",
  },
  showcase: {
    hero: {
      badge: "✦ Healthcare platform #1 · Kosovo",
      reserve: "Book now",
      dotsLabel: "Choose slide",
      slides: {
        speed: {
          title: "Book an Online Medical Visit",
          subtitle: "Find an available slot, choose your doctor, and confirm the visit in seconds.",
          button: "Book now",
        },
        nearby: {
          title: "Find the nearest specialists",
          subtitle: "Search by city, specialty, and distance to find care near you.",
          button: "Find a specialist",
        },
        vault: {
          title: "Your medical record, 100% secure",
          subtitle: "Reports, lab results, and clinical history stay protected in your personal Vault.",
          button: "Open my history",
        },
      },
    },
  },
  ads: {
    selectOwner: "Select paying owner",
    selectPriority: "Select priority",
    errorOwnerNotFound: "The paying account was not found. Choose a valid owner from the list.",
    requestAd: "Request Ad",
    platformInternal: "Platform ad",
    pendingApproval: "Pending approval",
    pendingPayment: "The ad has been created and is waiting for invoice payment.",
    requestSent: "The request was sent. Please pay the invoice in the invoices section for review.",
    waitingApproval: "waiting approval",
    marketingTab: "Marketing & Promotion",
    marketing: "Marketing",
    payConfirm: "Are you sure you want to pay this invoice from the Wallet?",
    cancelSuccess: "The request was cancelled successfully.",
  },
  medimarket: {
    orderCompleted: "Order completed",
    walletPaymentCompleted: "Payment was completed successfully from Wallet.",
    trackingCode: "Tracking code",
    requiresPrescription: "Medical prescription required",
  },
  inventory: {
    title: "Medical Devices",
    eyebrow: "Smart Inventory",
    description: "Track assets, lifecycle, maintenance, and QR codes for every device.",
    upgradeTitle: "Smart Inventory",
    upgradeDescription: "This module requires an active Inventory subscription in Service Hub. Manage medical assets, maintenance, and QR in one click.",
    activateFromHub: "Activate from Service Hub",
    searchPlaceholder: "Search: device, serial, category",
    statusAll: "Status: All",
    criticalityAll: "Criticality: All",
    scanQr: "QR Scan",
    newAsset: "New Device",
    loading: "Loading...",
    empty: "No devices found.",
    count: "{{count}} devices",
    headers: {
      assetId: "Asset ID",
      device: "Device",
      brandModel: "Brand / Model",
      status: "Status",
      location: "Location",
      criticality: "Criticality",
      warranty: "Warranty",
    },
    detail: {
      selectAsset: "Select a device from the list.",
      tabs: {
        overview: "Details",
        maintenance: "Maintenance",
        history: "History",
      },
      fields: {
        custody: "Custody",
        location: "Location",
        serial: "Serial",
        brand: "Brand",
        model: "Model",
        purchaseDate: "Purchase Date",
        warranty: "Warranty",
        department: "Department",
        assignee: "Assignee",
        created: "Created",
        updated: "Updated",
      },
      chooseStatus: "Choose status...",
      sendToService: "Send to Service",
      serviceDescriptionPlaceholder: "Describe the issue or service need",
      technicianNotesPlaceholder: "Technician notes",
      registering: "Registering...",
      reportIncident: "Report Incident",
      incidentDescriptionPlaceholder: "Describe the incident",
      downloadQr: "Download QR",
      qrSecurityNote: "The scan is verified by the backend before details are opened.",
    },
  },
  imaging: {
    roleBanner: "You entered the imaging module as {{role}}",
    upload: {
      title: "Upload Imaging Study",
      patientId: "Patient ID *",
      patientPlaceholder: "e.g. 384",
      studyType: "Study Type *",
      bodyPart: "Body Part *",
      bodyPartPlaceholder: "e.g. Chest, Left knee, Head",
      clinicalNote: "Clinical Note (optional)",
      clinicalNotePlaceholder: "Clinical findings, observations...",
      dropHint: "Click or drag the image here",
      fileHint: "JPG, PNG, WEBP · max 15 MB",
      submit: "Upload Study",
      errors: {
        fileType: "Only JPG, PNG, or WEBP are allowed.",
        fileSize: "The file exceeds 15 MB.",
        patientRequired: "Patient ID is required.",
        bodyPartRequired: "Body part is required.",
        fileRequired: "Choose an image file.",
        failed: "Upload failed. Please try again.",
      },
    },
  },
  messagesPage: {
    eyebrow: "Secure MSN",
    title: "Messages",
    description: "Private patient-professional conversations opened only with clinical context.",
    reconnecting: "Connection was interrupted. Retry {{current}}/{{max}}...",
    failedReconnect: "Connection failed after 5 attempts. Reload the page.",
  },
  superadmin: {
    verifyBusiness: "Verify",
    moduleApprovals: "Module Approvals",
    activateModule: "Activate Module",
  },
  billing: {
    b2bInvoices: "B2B SaaS Invoices",
    vat: "VAT",
    paymentSuccessful: "Payment completed successfully.",
  },
  business: {
    licenseUsage: "License Usage",
    doctorLimit: "Doctor Limit",
    usedSeats: "Used Seats",
  },
  themes: {
    lightFlat: "Light",
    dark: "Dark",
    gradientLight: "Gradient",
  },
  languages: {
    sq: "SQ",
    en: "EN",
    sr: "SR",
    tr: "TR",
  },
  roles: {
    business: "Business",
    doctor: "Doctor",
    specialist: "Specialist",
    technician: "Technician",
    patient: "Patient",
    admin: "Administration",
    superadmin: "Superadmin",
    student: "Student",
    guest: "Guest",
    none: "No active profile",
  },
  nav: {
    dashboard: "Dashboard",
    corporateDashboard: "Corporate Dashboard",
    search: "Search",
    patientHome: "My Page",
    professionalPanel: "My Panel",
    appointments: "Appointments",
    monitoring: "Monitoring",
    familyCare: "Family Care",
    clinicalHistory: "Clinical History",
    laboratory: "Laboratory",
    labResults: "Results",
    labAdmin: "Lab Panel",
    serviceHub: "Service Hub",
    inventory: "Inventory",
    jobs: "Job Offers",
    insurance: "Insurance",
    events: "Events",
    familyDashboard: "Family Dashboard",
    wallet: "Wallet",
    businessWallet: "Business Wallet",
    medimarket: "Medimarket",
    cart: "Cart",
    seller: "My Store",
    registerBusiness: "Register Business",
    myBlog: "My Blog",
    postModeration: "Blog Moderation",
    adsManagement: "Ads Management",
    invoices: "Invoices",
    messages: "Messages",
    departments: "Departments",
    hospitalBeds: "Beds",
    hospitalAdmissions: "Admissions",
    admin: "Admin",
    verifyDoctors: "Doctor Verification",
    account: "Account",
    businesses: "Businesses",
    myClinic: "My Clinic",
    reportTemplate: "Report Template",
  },
  professionalSettings: {
    tabs: { profile: "Profile", timeline: "Education & Experience", skills: "Skills & Languages", social: "Social Networks", weekly: "Weekly Schedule", exceptions: "Exceptions", security: "Security" },
    status: { publicActive: "Public CV active", publicInactive: "Public CV inactive", verified: "Verified", pendingVerification: "Verification pending" },
    actions: { viewPublicCv: "View public CV", marketingView: "Marketing view" },
  },
  invoices: {
    labels: { status: "Status" },
    status: { paid: "Paid", unpaid: "Unpaid", pending: "Pending", failed: "Failed", cancelled: "Cancelled" },
    medicalService: "Medical service",
    columns: { patient: "Patient", service: "Service", amount: "Amount", status: "Status", date: "Date", actions: "Actions" },
    list: { title: "Clinic invoices", summary: "{{count}} total invoices · {{amount}} EUR collected", loadErrorTitle: "Clinic invoices could not be loaded", loadErrorDescription: "Check your connection and try again.", emptyTitle: "No invoices yet", emptyDescription: "Invoices will appear after the first appointment payments." },
    actions: { payWithWallet: "Pay with Wallet", confirmPayment: "Confirm payment", paying: "Paying...", cancelRequest: "Cancel request", cancelRequestDescription: "This will cancel the advertising request and its unpaid invoice.", cancelling: "Cancelling..." },
    detail: { title: "Invoice details", amount: "Amount", receivedAmount: "Amount received", paidAmount: "Amount paid", transactionId: "Transaction ID", type: "Type", credit: "Credit", debit: "Debit", description: "Description", reference: "Reference", createdAt: "Created at", completedAt: "Completed at", balanceBefore: "Balance before", balanceAfter: "Balance after", generatingPdf: "Generating...", pdfGenerationFailed: "PDF could not be generated. Please try again.", pdfUnavailable: "PDF is available only for debit transactions." },
  },
  modules: {
    connecting: "This module is being connected",
    appointments: "Medical Appointments",
    monitoring: "Health Monitoring",
    laboratory: "Laboratory",
    insurance: "Health Insurance",
    events: "Events & Webinars",
    jobs: "Employment Platform",
    inventory: "Medical Inventory",
    serviceHub: "Service Hub",
    wallet: "Digital Wallet",
    medimarket: "Medical Market",
    messages: "Messages",
    clinical: "Clinical History",
    family: "Family Care",
    imaging: "Medical Imaging",
  },
  appointments: {
    title: "Medical Appointments",
    book: "Book Appointment",
    upcoming: "Upcoming appointments",
    past: "Past appointments",
    confirmed: "Confirmed",
    requested: "Request sent",
    completed: "Completed",
    cancelled: "Cancelled",
    noAppointments: "No appointments scheduled",
    selectDoctor: "Select a doctor",
    selectDate: "Select a date",
    selectTime: "Select a time",
    confirmPayment: "Confirm and pay with Wallet",
    insufficientFunds: "Insufficient balance",
    addFunds: "Add funds →",
    patientList: { eyebrow: "Patient appointments", title: "Bookings and payments", createPatient: "Create patient", total: "Total", totalDescription: "Appointments registered to your account.", confirmed: "Confirmed", confirmedDescription: "Paid and confirmed bookings.", pending: "Pending", pendingDescription: "Bookings awaiting payment.", historyTitle: "Appointment history", historyDescription: "Status, time and payment for every booking.", emptyTitle: "No appointments yet", emptyDescription: "Your first booked appointment will appear here.", doctorBusiness: "Doctor #{{doctorId}} · Business #{{businessId}}", service: "Service #{{serviceId}}", openWorkbench: "Open Workbench", starts: "Starts", ends: "Ends", invoice: "Invoice", noInvoice: "No invoice yet" },
    confirmation: { stepTitle: "Step 4 · Confirmation", stepDescription: "The booking becomes real only after the Wallet payment is completed.", clinic: "Clinic", service: "Service", doctor: "Doctor", specialization: "Specialization", date: "Date", time: "Time", price: "Price", selectClinic: "Select a clinic", selectService: "Select a service", selectSlot: "Select a slot", willAppear: "Will appear", walletNotice: "The Wallet payment is completed only after you confirm. The balance does not change until the backend returns the new value.", referenceOptional: "Reference (optional)", referencePlaceholder: "e.g. Cardiology check-up", insufficientFundsDescription: "Your Wallet does not have enough funds.", warning: "Warning", lowBalance: "The balance ({{balance}}) may not be enough for {{amount}}." },
  },
  insurance: {
    title: "Health Insurance",
    active: "Active Policy",
    coverage: "Possible coverage",
    noPolicy: "No active policy",
    covered: "Covered",
    partial: "Partial coverage",
    notCovered: "Not covered",
    viewPolicy: "View policy",
    contact: "Contact insurer",
    calculate: "Calculate",
    widgetTitle: "Insurance Coverage",
    check: "Check",
    checking: "Checking...",
    insurerCovers: "Insurer covers",
    youPay: "You pay",
    policyLabel: "Policy",
    noActivePolicy: "You have no active insurance policy.",
  },
  events: {
    title: "Events & Webinars",
    register: "Register",
    registered: "✓ Registered",
    registering: "Registering...",
    full: "Fully booked.",
    free: "Free",
    online: "Online",
    inPerson: "In Person",
    hybrid: "Hybrid",
    webinar: "Webinar",
    conference: "Conference",
    training: "Training",
    workshop: "Workshop",
    seminar: "Seminar",
    noEvents: "No active events",
  },
  jobs: {
    title: "Employment Platform",
    apply: "Apply",
    applying: "Applying...",
    applied: "✓ Applied",
    fullTime: "Full-time",
    partTime: "Part-time",
    contract: "Contract",
    onSite: "On-site",
    remote: "Remote",
    hybrid: "Hybrid",
    salary: "Salary",
    noOffers: "No active offers",
  },
  search: {
    title:          "Intelligent Search",
    placeholder:    "Search doctor, clinic or specialty...",
    placeholderShort: "Search doctor, clinic...",
    verified:       "Verified",
    viewProfile:    "View profile",
    publicProfile:  "Active public profile",
    noResults:      "No results found.",
    filters:        "Filters",
    advancedFilters:"Advanced Filters",
    radius:         "Radius (km)",
    gender:         "Gender",
    any:            "Any",
    female:         "Female",
    male:           "Male",
    tabs: {
      all:           "All",
      professionals: "Doctors",
      clinics:       "Clinics",
    },
    cities: {
      all:          "All cities",
      prishtina:    "Pristina",
      prizren:      "Prizren",
      gjilan:       "Gjilan",
      peja:         "Peja",
      mitrovica:    "Mitrovica",
    },
  },

  laboratory: {
    title:          "Laboratory",
    pageDesc:       "Choose categories, select analyses, and submit the request.",
    selectAtLeastOne: "Select at least 1 analysis.",
    myOrders:       "My orders",
    myOrdersDesc:   "Analysis status after Wallet payment.",
    noMyOrders:     "You do not have laboratory orders yet.",
    tests:          "tests",
    selfOrder:      "Self-order",
    panelTitle:     "Lab Technician Panel",
    ordersTitle:    "Analysis Orders",
    ordersDesc:     "Complete list of orders — enter results for active orders.",
    noOrders:       "No active orders",
    noOrdersHint:   "New orders will appear here once patients submit requests.",
    tableHeaders: {
      case:         "Case",
      patient:      "Patient",
      package:      "Package",
      doctor:       "Doctor",
      status:       "Status",
      time:         "Time",
      actions:      "Actions",
    },
    results:        "Results",
    enterResults:   "Enter Results",
    confirmResults: "Confirm Results",
    saving:         "Saving...",
    close:          "Close",
    valueRequired:  "Value is required.",
    dateRequired:   "Execution date is required.",
    filters: {
      status:       "Status",
    },
    form: {
      performedAt:  "Execution date",
      value:        "Value *",
      unit:         "Unit",
      reference:    "Reference (min-max)",
      note:         "Note",
      laboratoryNote: "Laboratory note (optional)",
      notePlaceholder: "Additional observations...",
    },
    levels: {
      high:         "High",
      normal:       "Normal",
      low:          "Low",
    },
    orderStatuses: {
      received:      "Received",
      in_progress:   "In Progress",
      results_ready: "Ready",
      delivered:     "Delivered",
      cancelled:     "Cancelled",
    },
  },

  admin: {
    title:          "Control Room",
    auditTrail:     "Audit Trail",
    allDomains:     "All domains",
    allSeverities:  "Any severity",
    recentEvents:   "recent events",
    noEvents:       "No events registered.",
    growth: {
      title:        "New Accounts — Last 7 Days",
      noData:       "No registrations in the last 7 days.",
      newAccounts:  "New accounts",
    },
    kpi: {
      totalAccounts:   "Total Accounts",
      activeAccounts:  "active accounts in system",
      appointments:    "Appointments (month)",
      appointmentsSub: "completed appointments",
      volume:          "Financial Volume",
      volumeSub:       "monthly transactions",
    },
  },

  wallet: {
    cardLink: { title: "Bank card", connect: "Link card", change: "Change card", expires: "expires", description: "For quick payments and invoices." },
    title: "Digital Wallet",
    eyebrow: "E-Wallet",
    financialTitle: "Financial Wallet",
    financialDescription: "Balance, analytics and payments are managed in real time.",
    notFoundTitle: "Wallet not found",
    notFoundDescription: "The balance cannot be loaded right now. Please try again later.",
    balance: "Balance",
    topUp: "Top Up",
    history: "Transaction history",
    noTransactions: "No transactions",
    credit: "Credit",
    debit: "Debit",
    completed: "Completed",
    pending: "Pending",
    failed: "Failed",
    insufficientFunds: "Insufficient Wallet balance.",
    invoicePaid: "Invoice paid successfully.",
    paymentSuccess: "Payment completed successfully.",
    totalBalance: "Total balance",
    myQrCode: "My QR code",
    transactions: "Transactions",
    activeSessions: "Active sessions",
    activeRefs: "Active references",
    qrSubtitle: "Scan for quick transfers",
    qr: { scanHint: "Scan with your banking or healthcare app for a quick transfer." },
  },
  auth: {
    resetEmailSent: "If the account exists, an email with instructions has been sent.",
    passwordChangedSuccess: "Your password was changed successfully. You can now log in.",
  },
  errors: {
    VERIFIED_PROFILE_REQUIRED: "Your account is under review. Posting will be allowed once you are verified.",
    INSUFFICIENT_FUNDS: "You do not have enough funds in your Wallet for this action.",
    ACCESS_DENIED: "You are not authorized to access this section.",
    ALREADY_EXISTS: "This information already exists in the system.",
    EMAIL_ALREADY_EXISTS: "This email is already registered. Sign in or use a different email address.",
    NOT_FOUND: "The requested resource was not found.",
    generic: "An error occurred. Please try again.",
    network: "Connection problem. Check your internet.",
    unauthorized: "Session expired. Please log in again.",
    notFound: "Page not found.",
    insufficientFunds: "Insufficient Wallet balance.",
    forbidden: "You don't have permission for this action.",
    invalidFileType: "The uploaded file is not a valid image or video.",
    reportNotFound: "Report was not found.",
    REPORT_REQUIRED_FIELDS_MISSING: "Please complete the required fields before signing.",
    fieldLocked: "Error: locked field cannot be deleted.",
    clinicalAccessDenied: "Access Denied: This section contains private clinical data.",
    retention_policy_active: "Finalized medical reports cannot be deleted for legal reasons.",
    hospitalMetadataRequired: "Hospital reports cannot be signed without admission metadata.",
    bedAlreadyOccupied: "The bed is already occupied.",
    invalidResetToken: "This link is invalid or has expired.",
  },
  logs: {
    accessGranted: "Access granted",
  },

  pages: {
    lab:       { eyebrow: 'Laboratory',              title: 'Analysis Results',         description: 'Latest clinical data with statuses computed by the system.' },
    events:    { eyebrow: 'Medical Platform',        title: 'Events & Webinars',        description: 'Live and recorded medical webinars, conferences and training.' },
    jobs:      { eyebrow: 'Medical Platform',        title: 'Job Offers',               description: 'Employment and career opportunities in the health sector.' },
    insurance: { eyebrow: 'Health Insurance',        title: 'Insurance Portal',         description: 'Your health policy and coverage from Kosovo insurance partners.' },
    wallet:    { eyebrow: 'Digital Wallet',          title: 'Wallet',                   description: 'Manage your balance, transactions and medical payments.' },
    favorites: { eyebrow: 'Favorites',               title: 'My Favorites',             description: 'Doctors, clinics and products you have saved.' },
    inventory: { eyebrow: 'Medical Assets',          title: 'Smart Inventory',          description: 'Manage medical equipment with QR and lifecycle tracking.' },
    serviceHub:{ eyebrow: 'Service Center',          title: 'Service Hub',              description: 'Activate and manage platform modules for your clinic.' },
    monitoring:{ eyebrow: 'Health Monitoring',       title: 'Monitoring',               description: 'Real-time health parameter tracking and measurement.' },
  },

  corporate: {
    title: "Corporate Dashboard",
    subtitle: "Consolidated view of all branches",
    tabs: {
      overview:  "Comparison",
      map:       "Map",
      branches:  "Branches",
      pending:   "Requests",
    },
    kpi: {
      branches:    "Branches",
      doctors:     "Doctors",
      appointments:"Appointments",
      revenue:     "Revenue",
      activeSub:   "active clinics",
      staffMedical:"medical staff",
      allBranches: "all branches",
      combinedEur: "combined EUR",
    },
    createOrg:   "New Organization",
    noBranches:  "No branches registered yet.",
    noOrgs:      "You have no registered organizations.",
    noOrgsHint:  "Create an organization and add your clinics as branches.",
    createFirst: "Create Your First Organization",
    requestJoin: "Request sent. Awaiting approval.",
    approved:    "Approved",
    denied:      "Denied",
    pending:     "Pending",
  },

  about: {
    title:    "About eShendetesia",
    subtitle: "Kosovo's leading healthcare platform",
    mission:  "Our mission is to connect patients with healthcare professionals in the most efficient and secure way.",
    vision:   "Vision",
    visionText: "Accessible healthcare for every citizen of Kosovo.",
    team:     "Our Team",
    contact:  "Contact",
  },

  monitoring: {
    session:     "Monitoring Session",
    sessions:    "Sessions",
    entries:     "Measurements",
    noSessions:  "No active sessions.",
    noEntries:   "No measurements for this session.",
    shareWith:   "Share with doctor",
    revokeAccess:"Revoke Access",
    grantActive: "Active access",
    grantNone:   "No access granted",
    metrics: {
      heartRate:  "Heart rate",
      bloodPressure: "Blood pressure",
      glucose:    "Glucose",
      weight:     "Weight",
      temperature:"Temperature",
    },
  },

  clinical: {
    reportEditor: {
      titleLabel: "Report title",
      summaryLabel: "History / Summary",
      diagnosisLabel: "Diagnosis / Clinical assessment",
      recommendationsLabel: "Recommendations",
      markdownHint: "Markdown: **bold**, *italic*, - lists",
      saveDraft: "Save draft",
      signAndFinalize: "Sign and Finalize",
      verificationPendingTitle: "Account verification is pending.",
      verificationPendingDescription: "You cannot sign reports.",
      auditNotice: "This report is electronically signed under the Clinical Audit Regulation.",
      finalizeTitle: "Sign and finalize report",
      finalizeDescription: "After signing, the report becomes read-only and access is audited.",
      finalizing: "Finalizing...",
      finalizeConfirm: "Finalize report",
      validationTitle: "The title must contain at least 3 characters.",
      specialistOnly: "Only specialists can sign the report.",
      specialistOnlyTitle: "Signing requires a specialist role",
      specialistOnlyDescription: "General doctors can save the report as a draft, but final signing is reserved for specialists.",
    },
    title:       "Clinical History",
    diagnoses:   "Diagnoses",
    reports:     "Reports",
    medications: "Medications",
    noDiagnoses: "No diagnoses registered.",
    noReports:   "No clinical reports.",
    addDiagnosis:"Add Diagnosis",
    requestLabs: "Request Lab Tests",
    viewReport:  "View Report",
    downloadPdf: "Download PDF",
    signReport:  "Sign Report",
    icdCode:     "ICD-10 Code",
    confirmedAt: "Confirmed on",
  },

  subscriptionExpiry: {
    days15: "You have 15 days before the subscription expires.",
    days7: "You have 7 days before the subscription expires.",
    days3: "Urgent: you have 3 days before module access is blocked.",
    expired: "The subscription has expired and module access is blocked.",
  },

  posts: {
    patientQuestion: "Patient Question",
    professionalPost: "Professional Post",
    summaryLabel: "Short Summary",
    officialBadge: "Official article",
    patientBadge: "Patient question",
    rejectionReason: "Rejection reason",
    unverifiedAlert: "Your post is pending approval",
    commentRestricted: "Only medical staff can comment on professional posts.",
    rejectionTitle: "Rejected",
    status: {
      published: "Published",
      pending: "Pending approval",
      rejected: "Rejected",
      draft: "Draft",
      scheduled: "Scheduled",
      expiring: "Expiring",
      expired: "Expired",
    },
    rejectionFallback: "The post requires corrections before publication.",
    moderation: {
      title: "Post Moderation",
      description: "Posts enter this queue as pending and appear in Showcase only after approval.",
      empty: "There are no posts pending review.",
      archiveEmpty: "There are no approved or rejected posts.",
      untitled: "Untitled",
      approvePublish: "Approve and publish",
      reject: "Reject",
      rejectTitle: "Reject post",
      rejectDescription: "Choose the reason shown to the author. Rejection does not delete the post.",
      extraNote: "Additional note for the author",
      rejectWithReason: "Reject with reason",
      tabs: {
        pending: "Pending",
        archive: "Regular",
      },
      reasons: {
        inaccurate: "Inaccurate information",
        unethical: "Unethical content",
        promotional: "Disallowed promotional content",
      },
    },
  },

  access: {
    unauthorized_role: "This role does not have access to the patient clinical file.",
    relationship_required: "A clinical relationship or active patient grant is required.",
    requestNewGrant: "Request a new access grant",
    clinicalForbidden: {
      title: "Access Forbidden",
      description: "This section contains private clinical data.",
    },
    moduleInactive: {
      title: "Module is not active yet",
      description: "Backend reports this module as inactive for now.",
    },
    profileRequired: {
      title: "Select an active profile",
      description: "This section depends on the active profile context returned by the backend.",
    },
    permissionMissing: {
      title: "Required permission missing",
      description: "This section requires: {{permissions}}. Contact an administrator.",
    },
    denied: {
      title: 'Isolated Section',
      description: 'This is an isolated {{role}} section. You do not have authorization for this context.',
    },
    clinicalIsolation: {
      title: 'Clinical Access Blocked',
      description: 'Administrators do not have access to clinical data (Constitution §III). Your role: {{role}}.',
    },
    notVerified: 'Your profile has not yet been verified by an administrator.',
    technicianBlock: 'Privacy Protection: This section (Agenda/Workbench) is reserved only for specialist medical staff.',
    pendingVerification: 'Pending Verification',
    switchBusiness: 'Switch to Business Mode',
    switchClinical: 'Return to Clinical Mode',
    businessMode: 'Business Mode',
    clinicalMode: 'Clinical Mode',
  },
};


